import { joinPath } from '../../core/utils';
import type { StorageBlockOptions, StoragePaths } from './types';

/** 按 pathPrefix + options 生成 form 路径 */
export function resolveStoragePaths(prefix: string, options?: StorageBlockOptions): StoragePaths {
  const segment = options?.listSegment ?? 'dataDisks';
  return {
    disks: joinPath(prefix, segment),
  };
}
